<template>
  <div class="register absolute petLogin" @click.stop>
    <div class="whiteBg" v-if="formItem === 1" @click.stop>
      <div class="list" :hidden="current !== 0">
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <input
                type="text"
                placeholder="输入账号"
                v-model="account"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input
                type="password"
                placeholder="填写登录密码"
                v-model="password"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="align-left">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input
                type="text"
                placeholder="填写验证码"
                class="codeIput"
                v-model="codeVal"
              />
              <div class="code" @click="getCaptcha"><img :src="codeUrl" /></div>
            </div>
          </div>
        </form>
      </div>
      <div class="logon" @click="submit">登录</div>
      <div class="tip"></div>
    </div>
  </div>
</template>
<script>
import { login } from "@api/index";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL } from "@utils";

const BACK_URL = "login_back_url";

export default {
  name: "pad-admin-login",
  data: function() {
    return {
      current: 0,
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: true
    };
  },
  mounted: function() {
		this.getCaptcha();
  },
  methods: {
    getCaptcha() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/padAdminCaptcha?" +
        "t=" + Date.parse(new Date());
    },
    async submit() {
      const { account, password, codeVal } = this;
      try {
        await this.$validator({
          account: [
            required(required.message("账号")),
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
          ],
          codeVal: [
						required(required.message("验证码")),
						attrs.length(4, attrs.length.message("验证码")),
						alpha_num(alpha_num.message("验证码"))
          ]
        }).validate({ account, password, codeVal });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login({ account, password, code: codeVal })
        .then(({ data }) => {
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          this.$store.commit("LOGIN", datas);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: '/' });
        })
        .catch(e => {
          this.$dialog.error(e.msg);
        });
    }
  }
};
</script>
<style scoped lang="scss">
.code img {
  width: 100%;
  height: 100%;
}
.petLogin {
  background: #00000080;
  position: absolute;
  z-index: 999;
  top: 0;

	.whiteBg {
		width: 700px;
    padding: 45px 30px 0 30px;
    border-radius : 16px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;

    .tip {
      height: 110px;
      text-align: center;
      line-height: 110px;
      font-size: 30px;
      color: #cccccc;
    }

		.logon {
			background: linear-gradient(90deg, #3fbcff 0%, #1FA4EB 100%);
      font-size: 34px;
      height: 86px;
      border-radius: 43px;
      line-height : 86px;
      margin-top : 47px;
		}

		.list {
			.item {
        padding: 47px 0 13px 0;
        input {font-size: 33px; flex: 1;}
				.codeIput {}
				.code {
					background-color: #ffffff;
          position: absolute;
          width: 200px;
          height: 70px;
          border-radius: 30px;
          color: #fff;
          line-height: 50px;
          text-align: center;
          bottom: 17px;
          right: 0;
          font-size: 25px;
				}
			}
		}
	}
}
</style>
